/**
 * Make a normalized panel link play well in the cloud browser. normalizePanelUrl
 * turns YouTube links into /embed/ URLs (right for iframes), but YouTube refuses
 * /embed/ as a top-level page (Error 153, no embedding referrer) — so in the
 * cloud browser, open the regular watch page instead.
 */
export function toCloudBrowserUrl(url: string): string {
  try {
    const u = new URL(url);
    const id = u.hostname === 'www.youtube.com' && u.pathname.match(/^\/embed\/([\w-]{11})$/)?.[1];
    if (id) return `https://www.youtube.com/watch?v=${id}`;
    return u.href;
  } catch { return url; }
}

/** Plain video files sync in everyone's own player — no cloud browser needed. */
export function isDirectVideoUrl(url: string): boolean {
  try { return /\.(mp4|webm|m4v|mov|ogv|ogg|m3u8)$/i.test(new URL(url).pathname); } catch { return false; }
}
